import { tok, tokPx } from '@sunwebgroup/ui-components'
import { Icon } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { css, styled } from 'styled-components'
import { useIntl } from '@/intl'
import { NavigationByWeeksContext } from '@/scopes/prices/components/PriceTable/NavigationByWeeksContext'

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 48px;
  width: 92px;
  padding: 0 ${tokPx('primitives_space_8')};
  border-radius: ${tokPx('primitives_corner_radius_full')};
  background: ${tok('primitives_color_neutral_0')};
  border: ${tokPx('semantics_dividers_tickness')} solid ${tok('primitives_color_neutral_100')};
  cursor: pointer;

  @media (min-width: ${tokPx('primitives_breakpoint_m_min')}) {
    display: none;
  }
`

const MobileButton = styled.div<{ $disabled?: boolean }>`
  width: 32px;
  height: 32px;
  background: ${tok('primitives_color_neutral_150')};
  border-radius: ${tokPx('primitives_corner_radius_full')};
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ $disabled }) =>
    $disabled
    && css`
      cursor: not-allowed;
      pointer-events: none;
      opacity: 0.38;
    `}
`

export function MobileNavigation() {
  const intl = useIntl()
  const { navigateRight, navigateLeft, isNavigationLeftEnabled, isNavigationRightEnabled }
    = React.use(NavigationByWeeksContext)

  const navigateLeftHandler = () => {
    navigateLeft()
  }

  const navigateRightHandler = () => {
    navigateRight()
  }

  return (
    <Wrapper>
      <MobileButton
        as="button"
        onClick={navigateLeftHandler}
        $disabled={!isNavigationLeftEnabled}
        tabIndex={0}
        type="button"
        aria-label={intl.formatMessage({ id: 'pagination_go_to_previous_page_label' })}
      >
        <Icon glyph="ChevronLeft" size={20} />
      </MobileButton>
      <MobileButton
        as="button"
        onClick={navigateRightHandler}
        $disabled={!isNavigationRightEnabled}
        tabIndex={0}
        type="button"
        aria-label={intl.formatMessage({ id: 'pagination_go_to_next_page_label' })}
      >
        <Icon glyph="ChevronRight" size={20} />
      </MobileButton>
    </Wrapper>
  )
}
